"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUrlSortFilter = exports.useStringArrayFilter = exports.usePrimitiveUrlFilter = exports.useDateUrlFilter = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var useUrlParam = function useUrlParam(paramKey, parser, defaultValue) {
  var location = (0, _reactRouterDom.useLocation)();
  var params = new URLSearchParams(location.search);
  var pageParam = params.get(paramKey);
  var parsedParam = pageParam && parser(pageParam);
  return parsedParam || defaultValue;
};
var useDateUrlFilter = function useDateUrlFilter(key) {
  var _usePrimitiveUrlFilte = usePrimitiveUrlFilter(key, function (value) {
      return Number(value);
    }, 0),
    _usePrimitiveUrlFilte2 = (0, _slicedToArray2.default)(_usePrimitiveUrlFilte, 2),
    dateTime = _usePrimitiveUrlFilte2[0],
    setDateTime = _usePrimitiveUrlFilte2[1];
  var date = (0, _react.useMemo)(function () {
    return dateTime ? new Date(dateTime) : undefined;
  }, [dateTime]);
  var setUrlDate = function setUrlDate(date) {
    var dateTime = date ? date.getTime() : 0;
    setDateTime(dateTime);
  };
  return [date, setUrlDate];
};
exports.useDateUrlFilter = useDateUrlFilter;
var usePrimitiveUrlFilter = function usePrimitiveUrlFilter(key, parser, defaultValue) {
  var urlParam = useUrlParam(key, parser, defaultValue);
  var _useState = (0, _react.useState)(urlParam),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentParam = _useState2[0],
    setCurrentParam = _useState2[1];
  (0, _react.useEffect)(function () {
    if (urlParam !== currentParam) {
      setCurrentParam(urlParam);
    }
  }, [urlParam]);
  return [currentParam, setCurrentParam];
};
exports.usePrimitiveUrlFilter = usePrimitiveUrlFilter;
var useUrlSortFilter = function useUrlSortFilter(name, defaultValue) {
  var _usePrimitiveUrlFilte3 = usePrimitiveUrlFilter(name, function (value) {
      return value;
    }, defaultValue),
    _usePrimitiveUrlFilte4 = (0, _slicedToArray2.default)(_usePrimitiveUrlFilte3, 2),
    sort = _usePrimitiveUrlFilte4[0],
    setSort = _usePrimitiveUrlFilte4[1];
  return [sort, setSort];
};
exports.useUrlSortFilter = useUrlSortFilter;
var useStringArrayFilter = function useStringArrayFilter(name, defaultValue) {
  var _usePrimitiveUrlFilte5 = usePrimitiveUrlFilter(name, function (value) {
      return value;
    }, defaultValue.join(',')),
    _usePrimitiveUrlFilte6 = (0, _slicedToArray2.default)(_usePrimitiveUrlFilte5, 2),
    arrayString = _usePrimitiveUrlFilte6[0],
    setArrayString = _usePrimitiveUrlFilte6[1];
  var array = (0, _react.useMemo)(function () {
    return arrayString ? arrayString.split(',') : undefined;
  }, [arrayString]);
  var setArray = (0, _react.useCallback)(function (array) {
    var arrayString = array ? array.join(',') : defaultValue.join(',');
    setArrayString(arrayString);
  }, [setArrayString, defaultValue]);
  return [array, setArray];
};
exports.useStringArrayFilter = useStringArrayFilter;